module.exports = __webpack_public_path__ + "img/hkig2.79d53141.png";